export default "__VITE_ASSET__D35PCAP3__"